type LiverActionKind = 'record' | 'upload' | 'line' | 'edit'
type SidebarStatusFilter = 'all' | 'active' | 'inactive' | 'graduated'

export function actionVisibilityClass(kind: LiverActionKind): string {
  return kind === 'record' || kind === 'upload' ? 'hidden sm:inline-flex' : 'inline-flex'
}

export function sidebarDesktopWidthClass(collapsed: boolean): string {
  return collapsed ? 'md:w-20' : 'md:w-72'
}

export function sidebarStatusFilterLabel(status: SidebarStatusFilter): string {
  switch (status) {
    case 'all':
      return 'すべて'
    case 'active':
      return '稼働中'
    case 'inactive':
      return '休眠'
    case 'graduated':
      return '卒業'
  }
}
